import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/base.css'
import './assets/table.scss'
import './assets/form.scss'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { get, post ,upload} from './http/http';
import api from './http/api';
import getDate from './utils/getDate';
import getNum from './utils/getNum';

import store from './store'
import VueMeta from 'vue-meta'
import loading from './components/loading';
import pagination from './components/pagination';
import confirmTip from './components/confirmTip';
import i18n from './lang';

import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
 import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
// Prism
import Prism from 'prismjs';
// highlight code
import 'prismjs/components/prism-json';
VueMarkdownEditor.use(vuepressTheme, {
    Prism
});
import createLineNumbertPlugin from '@kangc/v-md-editor/lib/plugins/line-number/index';
import mavonEditor from 'mavon-editor'
    import 'mavon-editor/dist/css/index.css'
    Vue.use(mavonEditor);
VueMarkdownEditor.use(createLineNumbertPlugin());
Vue.use(VueMarkdownEditor);
Vue.use(ElementUI); //element组件
Vue.use(VueMeta)
Vue.use(api);
Vue.use(loading); //加载动画
Vue.use(pagination);
Vue.use(confirmTip);//确认操作提示

Vue.config.productionTip = false
Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$upload = upload;
Vue.prototype.$getDate = getDate;
Vue.prototype.$getNum = getNum;

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
})

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})




new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')